import { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Star } from "lucide-react";

const quotes = [
  {
    quote:
      "Kada sam otvarao restoran, tražio sam saradnika koji shvata da salveta na stolu mora biti bela — ne skoro bela. TOP WASH razume razliku i ispunjava standard svakog jutra.",
    author: "Marko S.",
    role: "Vlasnik restorana · Vračar",
  },
  {
    quote:
      "Otvorili smo pansion sa 12 soba i posteljina nam je najveća briga. Dobili smo fiksan raspored, kvalitet, tačan mesečni obračun. Preporuka za sve u smeštaju.",
    author: "Milena T.",
    role: "Direktor pansiona · Zemun",
  },
  {
    quote:
      "Radimo cateringе do 200 ljudi vikendom. TOP WASH je jedini sa kojim se od početka nismo bavili logistikom — dolaze, uzmu, vrate čisto, spremno, spakovano.",
    author: "Ivan & Nikola M.",
    role: "Catering studio · Novi Beograd",
  },
];

export default function Testimonials() {
  const [i, setI] = useState(0);
  useEffect(() => {
    const t = setInterval(() => setI((v) => (v + 1) % quotes.length), 6500);
    return () => clearInterval(t);
  }, []);

  return (
    <section
      id="testimonials"
      data-testid="testimonial-carousel"
      className="tw-section relative overflow-hidden"
    >
      <div
        className="glow-blob"
        style={{
          top: "10%",
          left: "-10%",
          width: 500,
          height: 500,
          background: "radial-gradient(circle, #0b6cc9 0%, transparent 60%)",
          opacity: 0.35,
        }}
      />

      <div className="relative z-10 tw-container">
        <div className="text-center mb-10 md:mb-20">
          <div className="overline">05 — Šta kažu klijenti</div>
          <h2 className="mt-4 md:mt-6 tw-heading-section">
            Reč naših
            <br />
            <span className="blue-text font-display italic">poslovnih partnera.</span>
          </h2>
        </div>

        <div className="max-w-4xl mx-auto">
          <div className="tw-card p-6 sm:p-8 md:p-14 relative overflow-hidden">
            <div className="flex justify-center gap-1 mb-8">
              {[...Array(5)].map((_, s) => (
                <Star key={s} size={18} strokeWidth={0} fill="#55d0ff" className="drop-shadow-[0_0_8px_rgba(85,208,255,0.6)]" />
              ))}
            </div>

            <div className="relative min-h-[200px] sm:min-h-[220px] md:min-h-[220px]">
              <AnimatePresence mode="wait">
                <motion.blockquote
                  key={i}
                  initial={{ opacity: 0, y: 24 }}
                  animate={{ opacity: 1, y: 0 }}
                  exit={{ opacity: 0, y: -20 }}
                  transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
                  data-testid={`testimonial-quote-${i}`}
                  className="text-center"
                >
                  <p className="font-sans-tw text-base sm:text-lg md:text-xl lg:text-2xl leading-[1.5] text-white font-light">
                    <span className="text-[#55d0ff] text-4xl leading-none">&ldquo;</span>
                    {quotes[i].quote}
                    <span className="text-[#55d0ff] text-4xl leading-none">&rdquo;</span>
                  </p>
                  <div className="mt-10 flex flex-col items-center gap-2">
                    <div className="w-12 h-12 rounded-full bg-gradient-to-br from-[#55d0ff] to-[#0b6cc9] flex items-center justify-center font-heading text-white shadow-lg shadow-[#1fa8ff]/40">
                      {quotes[i].author.charAt(0)}
                    </div>
                    <div className="font-heading-md text-lg text-white">{quotes[i].author}</div>
                    <div className="overline text-[10px]">{quotes[i].role}</div>
                  </div>
                </motion.blockquote>
              </AnimatePresence>
            </div>
          </div>

          <div className="mt-10 flex items-center justify-center gap-3">
            {quotes.map((_, idx) => (
              <button
                key={idx}
                onClick={() => setI(idx)}
                data-testid={`testimonial-dot-${idx}`}
                aria-label={`Prikaži iskustvo ${idx + 1}`}
                className={`h-1.5 rounded-full transition-all duration-500 ${
                  idx === i
                    ? "w-12 bg-gradient-to-r from-[#55d0ff] to-[#1fa8ff]"
                    : "w-6 bg-white/20 hover:bg-white/40"
                }`}
              />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
